var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9494 11.6641C10.7891 12.0764 10.5188 12.3512 10.2119 12.3512H6.33628C6.02477 12.3512 5.75907 12.0764 5.59873 11.6641H0.5V12.4657C0.523447 12.7595 0.661504 13.0323 0.884357 13.2252C1.10721 13.418 1.39698 13.5155 1.69108 13.4965H14.8846C15.1787 13.5155 15.4684 13.418 15.6913 13.2252C15.9141 13.0323 16.0522 12.7595 16.0756 12.4657V11.6641H10.9494Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24751 4.33243H13.3259V10.7459H14.7002V3.21923C14.7039 3.03289 14.6337 2.85266 14.5049 2.7179C14.3762 2.58314 14.1993 2.5048 14.013 2.5H2.56035C2.37403 2.5048 2.19719 2.58314 2.06844 2.7179C1.93969 2.85266 1.86949 3.03289 1.87319 3.21923V10.7459H3.24751V4.33243Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptop);
export default __webpack_public_path__ + "static/media/icon-laptop.a6e0c2351edd96e70afb2fb4b9d412a1.svg";
export { ForwardRef as ReactComponent };